module.exports = __webpack_public_path__ + "img/Working.ba2312e6.svg";